/*
  header.js - NOTFORTOMORROW OS2.0 - JS surface 1 (header/nav)
  <store-header> web component. Progressive enhancement only: the header is a
  working <nav> with real links before this runs. Loaded by sections/header.liquid.
  Behaviour: disclosure nav (keyboard + aria-expanded/haspopup), mobile drawer
  (uses the shared <nft-dialog> primitive), sticky-on-scroll, cart-count update.
*/

class StoreHeader extends HTMLElement {
  connectedCallback() {
    this._initDisclosure();
    this._initSticky();
    this._initCartCount();
  }

  /* Keyboard-operable mega-menu / dropdown disclosure. */
  _initDisclosure() {
    const pairs = [];
    this.querySelectorAll('[data-disclosure-toggle]').forEach((btn) => {
      const panelId = btn.getAttribute('aria-controls');
      const panel = panelId && this.querySelector(`#${CSS.escape(panelId)}`);
      if (!panel) return;
      btn.setAttribute('aria-expanded', 'false');
      pairs.push({ btn, panel });

      const setOpen = (state) => { btn.setAttribute('aria-expanded', String(state)); panel.hidden = !state; };
      btn.addEventListener('click', () => {
        const willOpen = btn.getAttribute('aria-expanded') !== 'true';
        // Single-open: collapse the others first.
        pairs.forEach((p) => { if (p.btn !== btn) { p.btn.setAttribute('aria-expanded', 'false'); p.panel.hidden = true; } });
        setOpen(willOpen);
      });
      // ESC closes and returns focus.
      panel.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') { setOpen(false); btn.focus(); }
      });
    });

    // Close any open disclosure on outside-click or when focus leaves the header.
    const closeAll = () => pairs.forEach((p) => { p.btn.setAttribute('aria-expanded', 'false'); p.panel.hidden = true; });
    document.addEventListener('click', (e) => { if (!this.contains(e.target)) closeAll(); });
    this.addEventListener('focusout', (e) => { if (!this.contains(e.relatedTarget)) closeAll(); });
  }

  /* Sticky-on-scroll: toggle a class, CSS does the rest. */
  _initSticky() {
    if (this.dataset.sticky !== 'true') return;
    let last = 0;
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      this.classList.toggle('is-stuck', y > 4);
      // TODO: optional hide-on-scroll-down / show-on-scroll-up.
      last = y;
    }, { passive: true });
  }

  /* Update the cart count badge when cart.js dispatches cart:updated. */
  _initCartCount() {
    const badge = this.querySelector('[data-cart-count]');
    if (!badge) return;
    document.addEventListener('cart:updated', (e) => {
      const count = e.detail && typeof e.detail.item_count === 'number' ? e.detail.item_count : null;
      if (count === null) return;
      badge.textContent = count;
      badge.hidden = count === 0;
      // announce() is imported where needed; header keeps the badge in sync only.
    });
  }
}
if (!customElements.get('store-header')) customElements.define('store-header', StoreHeader);
